import { unzipSync } from 'fflate';
import mapService from '@/services/mapService';

const validateBoundaryFile = async (file) => {
  const state = {
    file: null,
    json: null,
  };

  const fileData = await file.arrayBuffer();

  if (mapService.isKmz(file)) {
    const buff = new Uint8Array(fileData);

    const archivedFiles = Object.values(unzipSync(buff));

    if (archivedFiles.length > 1) {
      const error = new Error();
      error.key = 'unsupportedGeometry';
      throw error;
    }

    const maybeKml = archivedFiles[0];
    state.file = maybeKml.buffer;
  } else {
    try {
      state.file = fileData;
    } catch (error) {
      error.key = 'networkError';
      throw error;
    }
  }

  try {
    const decodedFile = new TextDecoder().decode(state.file);

    if (mapService.isKml(file) || mapService.isKmz(file)) {
      try {
        const kmlDOM = new DOMParser().parseFromString(decodedFile, 'text/xml');
        const convertedData = mapService.kmlToGeoJSON.kml(kmlDOM);
        state.json = convertedData;
      } catch (error) {
        error.key = 'wrongFormat';
        throw error;
      }
    } else {
      const boundaryJSON = JSON.parse(decodedFile);
      if (mapService.isSupportedGeoJsonFormat(boundaryJSON)) {
        state.json = boundaryJSON;
      } else {
        const error = new Error();
        error.key = 'wrongJSON';
        throw error;
      }
    }
  } catch (error) {
    error.key = 'wrongFormat';
    throw error;
  }

  if (mapService.isUnsupportedCRS(state.json)) {
    const error = new Error();
    error.key = 'wrongCRS';
    throw error;
  }

  if (!mapService.isSupportedGeometry(state.json)) {
    const error = new Error();
    error.key = 'unsupportedGeometry';
    throw error;
  }

  try {
    const result = mapService.getGeometryByType(state.json);
    return result;
  } catch (error) {
    console.log('Currentrly unsupported file: ', state.json);
    error.key = 'wrongGeoJSONFormat';
    throw error;
  }
};

export { validateBoundaryFile };
